// extracted by mini-css-extract-plugin
module.exports = {"windowSection":"PortfolioCard_windowSection__1f-cm"};